export const formatPatientWeight = (weight: number, weightUnit = 'lb') =>
  `Patient weight: ${weight} ${weightUnit}`;
